import { render } from "./wsLog.vue?vue&type=template&id=180654d0&scoped=true"
import script from "./wsLog.vue?vue&type=script&lang=js"
export * from "./wsLog.vue?vue&type=script&lang=js"

import "./wsLog.vue?vue&type=style&index=0&id=180654d0&scoped=true&lang=css"

import exportComponent from "D:\\xyzw\\springboot-vue-demo\\vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-180654d0"]])

export default __exports__